import { motion } from 'framer-motion';
import { Star, Quote, Sparkles, MessageCircle } from 'lucide-react';

const TestimonialsPage = () => {
  const testimonials = [
    {
      name: "Sabrina Wells",
      service: "Knotless Braids",
      text: "The absolute best experience I've had in Charlotte. The attention to detail and the atmosphere were incredibly professional. My braids lasted 9 weeks and still looked fresh!",
      image: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=400&h=400&fit=crop",
      rating: 5
    },
    {
      name: "Tasha Miller",
      service: "Boho Box Braids",
      text: "Moyhe is an artist. She understood exactly what I wanted and executed it perfectly without any tension on my edges. Worth every cent.",
      image: "https://images.unsplash.com/photo-1523824921871-d6f1a15151f1?w=400&h=400&fit=crop",
      rating: 5
    },
    {
      name: "Aaliyah Reed",
      service: "Stitched Cornrows",
      text: "Finally found someone who respects my time and my scalp! On time, professional, and the salon is beautiful. 10/10 recommendation.",
      image: "https://images.unsplash.com/photo-1509114397022-ed747cca3f65?w=400&h=400&fit=crop",
      rating: 5
    },
    {
      name: "Maya Johnson",
      service: "Bora Braids",
      text: "I travel from Raleigh just to get my hair done here. The quality of work is unmatched. You can really feel the 30 years of experience.",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop",
      rating: 5
    }
  ];

  return (
    <div className="pt-24 pb-32 bg-cream min-h-screen relative overflow-hidden">
      <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-gold/5 rounded-full blur-[150px] -mr-96 -mt-96"></div>

      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-24"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gold/10 border border-gold/20 mb-6 text-gold font-bold text-[10px] uppercase tracking-[0.3em]">
            <MessageCircle size={14} />
            Client Voice
          </div>
          <h1 className="text-6xl md:text-9xl font-serif font-bold text-dark tracking-tighter mb-8 italic">
            Echoes of <br /><span className="text-gold not-italic">Satisfaction</span>
          </h1>
          <p className="text-xl text-gray-500 max-w-2xl mx-auto font-light leading-relaxed">
            Real stories from our esteemed clients. Experience the transformation through their eyes.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ y: -10 }}
              className="group relative bg-white p-12 rounded-[50px] shadow-[0_20px_60px_rgba(0,0,0,0.03)] border border-transparent hover:border-gold/20 transition-all duration-500"
            >
              <div className="absolute top-10 right-12 text-gold opacity-[0.05] group-hover:opacity-10 scale-[4] transition-opacity duration-700">
                <Quote size={80} />
              </div>

              <div className="flex items-center gap-6 mb-10">
                <div className="relative">
                  <div className="absolute inset-0 bg-gold rounded-full scale-110 blur-sm opacity-0 group-hover:opacity-20 transition-opacity"></div>
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="relative w-20 h-20 rounded-full object-cover border-2 border-gold/30"
                  />
                </div>
                <div>
                  <h3 className="text-2xl font-serif font-bold text-dark">{testimonial.name}</h3>
                  <p className="text-gold font-bold uppercase tracking-widest text-[9px] mb-1">{testimonial.service}</p>
                  <div className="flex gap-1">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} size={10} className="fill-gold text-gold" />
                    ))}
                  </div>
                </div>
              </div>

              <p className="text-gray-500 text-lg leading-relaxed font-light italic italic">
                "{testimonial.text}"
              </p>

              <div className="mt-8 pt-8 border-t border-gray-50 flex items-center gap-2">
                <Sparkles className="text-gold w-4 h-4" />
                <span className="text-[10px] uppercase tracking-[0.2em] font-black text-dark/40 italic">Verified Selection</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TestimonialsPage;
